
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'custom-notifications',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class CustomNotifications extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    private isExpand: boolean = false;
    // ---------------------------------------------------------------------
    // Methods

}
